(() => {
  const SELECTOR = '[data-recommendation-add]';

  const setStatus = (button, message) => {
    const section = button.closest('.loyly-cart__recommendations');
    const status = section?.querySelector('[data-recommendation-status]');
    if (status) status.textContent = message;
  };

  const addRecommendation = async (button) => {
    const variantId = Number(button.dataset.variantId);
    const title = button.dataset.recommendationTitle || 'Product';

    if (!variantId || button.disabled || button.getAttribute('aria-busy') === 'true') return;

    button.setAttribute('aria-busy', 'true');
    setStatus(button, '');

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Unable to add this product.');
      }

      button.classList.add('is-added');
      button.disabled = true;
      button.setAttribute('aria-label', `Already in cart: ${title}`);
      setStatus(button, `${title} added to your cart.`);

      window.setTimeout(() => window.location.reload(), 450);
    } catch (error) {
      button.removeAttribute('aria-busy');
      setStatus(button, error.message || 'Unable to add this product. Please try again.');
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(SELECTOR);
    if (button) addRecommendation(button);
  });
})();
